/* eslint-disable no-unused-vars */
import React from "react";

import { FormattedDate, FormattedTime } from "react-intl";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";

import _ from "lodash";

import NodeIcon from "./node-icon";

interface LastValueProps {
  // nodes: any[];
  data: any; // any[];
  widgetStatic?: boolean;
  widgetTitle?: string;
}

function LastValue(props: LastValueProps) {
  const {
    // nodes,
    data,
    // widgetStatic,
  } = props;
  // console.log("LV data", data);
  const isArray = Array.isArray(data);
  // TODO sensor name (tag name)

  let result = <>No Data</>;
  if (!data) {
    return result;
  }

  const date: Date | undefined =
    isArray === false && data.date
      ? new Date(data.date)
      : _.min(
          data
            .filter((item: any) => !_.isNil(item.date))
            .map((item: any) => new Date(item.date))
        );
  // console.log("date is ", date);

  if (!!isArray) {
    result = (
      <List dense style={{ overflow: "auto", height: "100%" }}>
        {data.map((item: any, index: number) => (
          <ListItem key={index}>
            <ListItemIcon>
              <NodeIcon subClass={item.subclass} __typename={"TagNode"} />
              {/* <img
                src={`http://demo.adcon.at/images/node/TAG/${item.subclass}.gif`}
                alt=""
                width="20"
                height="20"
              /> */}
            </ListItemIcon>
            <ListItemText
              primary={`${
                !_.isNil(item.value) ? item.value.toFixed(2) : "---"
              } ${item.unit}`}
            />
          </ListItem>
        ))}
      </List>
    );
  } else {
    if (!_.isNil(data.value)) {
      result = (
        <Typography variant="h4">
          {data.value.toFixed(2)}
          {data.unit}
        </Typography>
      );
    }
  }

  return (
    <>
      {result}
      {date && (
        <Typography variant="subtitle2">
          <FormattedDate
            value={date}
            year="numeric"
            month="2-digit"
            day="2-digit"
          />
          &nbsp;
          <FormattedTime value={date} />
        </Typography>
      )}
    </>
  );
}

export default LastValue;
